export function sortWaitingAreaRooms(roomA, roomB) {
  // Sort #1 - room.isCurrentUserAnsweringThisCall DESC
  if (roomA.isCurrentUserAnsweringThisCall && !roomB.isCurrentUserAnsweringThisCall) return -1;
  // roomA comes before roomB
  else if (!roomA.isCurrentUserAnsweringThisCall && roomB.isCurrentUserAnsweringThisCall) return 1; // roomB comes before roomA

  // Sort #2 - room.mainParticipant.status === "Idle"
  if (roomA.mainParticipant.status === 'Idle' && roomB.mainParticipant.status !== 'Idle') return -1;
  // roomA comes before roomB
  else if (roomA.mainParticipant.status !== 'Idle' && roomB.mainParticipant.status === 'Idle') return 1; // roomB comes before roomA

  // Sort #3 - room.mainParticipant.status === "Waiting"
  if (roomA.mainParticipant.status === 'Waiting' && roomB.mainParticipant.status !== 'Waiting') return -1;
  // roomA comes before roomB
  else if (roomA.mainParticipant.status !== 'Waiting' && roomB.mainParticipant.status === 'Waiting') return 1; // roomB comes before roomA

  // Sort #4 - room.mainParticipant.status === "Attended"
  if (roomA.mainParticipant.status === 'Attended' && roomB.mainParticipant.status !== 'Attended') return -1;
  // roomA comes before roomB
  else if (roomA.mainParticipant.status !== 'Attended' && roomB.mainParticipant.status === 'Attended') return 1; // roomB comes before roomA

  // Sort #X - room.durationInCurrentStatusInSeconds DESC
  if (roomA.durationInCurrentStatusInSeconds > roomB.durationInCurrentStatusInSeconds) return -1;
  // roomA comes before roomB
  else if (roomA.durationInCurrentStatusInSeconds < roomB.durationInCurrentStatusInSeconds) return 1; // roomB comes before roomA

  return 0; // no order change
}
